import sessionConstants from "csi/sessionConstants";

/**
 * load and initialize the microsoft clarity library
 */
export function init(): void {
	if (!sessionConstants.clarityId) {
		return;
	}

	// Begin boilerplate code
	(function(c, l, a, r, i, t, y): void {
		c[a]=c[a]||function(): void {(c[a].q=c[a].q||[]).push(arguments);};
		t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
		y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t, y);
	})(window, document, "clarity", "script", sessionConstants.clarityId);
	// End boilerplate code
}